import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { titleize } from 'underscore.string';
import { Button, Alert, FormGroup, FormControl, ControlLabel, Modal } from 'react-bootstrap';
import validator from 'email-validator';
import { withTranslation } from 'react-i18next';
class SendEmailModal extends React.Component {
    constructor(props) {
        super(props);
        this.send = () => {
            const { t } = this.props;
            const emails = this.state.to.replace(/' '/g, '').split(',');
            const invalidEmailAddresses = emails.filter(ea => !validator.validate(ea));
            if (invalidEmailAddresses.length > 0) {
                this.setState({ error: t('VALID_EMAIL_ONLY') });
            }
            else {
                this.props.onSend(_.uniq(emails));
                this.setState(this.getInitialState());
                this.props.onHide();
            }
        };
        this.state = this.getInitialState();
    }
    getInitialState() {
        return {
            error: null,
            to: '',
        };
    }
    componentWillUnmount() {
        this.setState(this.getInitialState());
    }
    addRecipients(e) {
        this.setState({ to: e.target.value.trim() });
    }
    renderError() {
        if (!this.state.error) {
            return '';
        }
        return (React.createElement(Alert, { bsStyle: "warning" }, this.state.error));
    }
    render() {
        const { t } = this.props;
        return ((React.createElement(Modal, { show: this.props.show, onHide: this.props.onHide, enforceFocus: false },
            React.createElement(Modal.Header, { "data-testid": "undefined-26e78579" },
                React.createElement("strong", { "data-testid": "strong-a5b27bb3" }, t('EMAIL_THIS_INVOICE'))),
            React.createElement(Modal.Body, { "data-testid": "undefined-0c58f686" },
                this.renderError(),
                React.createElement("div", { "data-testid": "div-862b324b" },
                    React.createElement(FormGroup, null,
                        React.createElement(ControlLabel, { "data-testid": "undefined-26e78580" }, titleize(t('RECIPIENT', { count: 1 }))),
                        React.createElement(FormControl, { "data-testid": "undefined-26e78581", onChange: e => this.addRecipients(e), type: "text", value: this.state.to })))),
            React.createElement(Modal.Footer, { "data-testid": "undefined-700c8c8a" },
                React.createElement(Button, { "data-testid": "Button-26e78579", bsStyle: "danger", type: "button", onClick: this.props.onHide }, titleize(t('CLOSE'))),
                React.createElement(Button, { "data-testid": "Button-26e78902", disabled: this.state.to === '', bsStyle: "primary", type: "button", onClick: this.send }, t('SEND'))))));
    }
}
SendEmailModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onSend: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
};
export default withTranslation()(SendEmailModal);
